<template>
    <div class="personnel">
        <div class="top-select">
            <el-select v-model="allOneValue" @change="allOneClick" class="select" placeholder="请选择">
                <el-option v-for="item in allOne" :key="item.value" :label="item.label"
                    :value="{ value: item.value, label: item.label }">
                </el-option>
            </el-select>

            <el-date-picker class="dataTime" v-model="timer" type="monthrange" @change="handleTime" align="right"
                unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" value-format="yyyy-MM"
                :picker-options="pickerOptions">
            </el-date-picker>

        </div>
        <div class="index-cont">
            <!-- 左侧 -->
            <div class="index-1">
                <div class="left-top-1" @mouseover="changIconsBlockPosition('enter', 1)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 93%">
                            <div class="div-index">
                                <p class="cont-bg-event">在职人数同比增长</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsFir" class="cont-position" :timeArray="timer"
                                        @chooseData="childByValue" :infoTitle="'在职人数同比增长'" @download="download"
                                        :idName="'myChartC'" :stringPaintChart="topDataOne" :allOneValue="countryId"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.QURYTBZC_DATA" />
                                </div>
                            </div>
                            <div class="width-height" style="height: 80%">
                                <div id="myChartC" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>

                <div class="left-top-1" @mouseover="changIconsBlockPosition('enter', 3)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 93%">
                            <div class="div-index">
                                <p class="cont-top-bg">人员净增</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsThr" class="cont-position" @chooseData="childByValue"
                                        :infoTitle="'人员净增'" @download="download" :idName="'myChart33'"
                                         :allOneValue="countryId"
                                        :stringPaintChart="drawLine3" @changeTextColor="changeTextColor"
                                        :details="COUNSTDATE.QYJZ_DATA" />
                                </div>
                            </div>
                            <div class="width-height" style="height: 82%">
                                <div id="myChart33" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>

            <div class="index-2">
                <div class="border-left-1" @mouseover="changIconsBlockPosition('enter', 4)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 100%">
                            <div class="div-index">
                                <p class="cont-top-bg">人效</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsFou" class="cont-position" :timeArray="timer"
                                        @chooseData="childByValue" :infoTitle="'人效'" @download="download"
                                        :idName="'myChart44'" :stringPaintChart="drawLine4" :allOneValue="countryId"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.RX_DATA" />
                                </div>
                            </div>
                            <div class="width-height" style="height: 80%">
                                <div id="myChart44" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>

                <div class="border-left-2" @mouseover="changIconsBlockPosition('enter', 5)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 100%">
                            <div class="div-index">
                                <p class="cont-top-bg">招聘留存率</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsFiv" class="cont-position" :timeArray="timer"
                                        @chooseData="childByValue" :infoTitle="'招聘留存率'" @download="download"
                                        :idName="'myChart55'" :stringPaintChart="drawLine5" :allOneValue="countryId"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.JDZPLCL_DATA" />
                                </div>
                            </div>
                            <div class="width-height" style="height: 82%">
                                <div id="myChart55" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>

                <div class="border-left-2" @mouseover="changIconsBlockPosition('enter', 6)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 100%">
                            <div class="div-index">
                                <p class="cont-top-bg">离职替换率</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsSix" class="cont-position" :timeArray="timer"
                                        @chooseData="childByValue" :infoTitle="'离职替换率'" @download="download"
                                        :idName="'myChart66'" :stringPaintChart="drawLine6" :allOneValue="countryId"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.LZTHL_DATA" />
                                </div>
                            </div>
                            <div class="width-height" style="height: 82%">
                                <div id="myChart66" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>

            <div class="index-3">
                <div class="left-top-1" @mouseover="changIconsBlockPosition('enter', 2)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 93%">
                            <div class="div-index">
                                <p class="cont-top-bg">招聘完成率</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsSec" class="cont-position" :timeArray="timer"
                                        @chooseData="childByValue" :infoTitle="'招聘完成率'" @download="download"
                                        :idName="'myChart22'" :stringPaintChart="drawLine2" :allOneValue="countryId"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.ZPWCL_DATA" />
                                </div>
                            </div>
                            <div class="width-height" style="height: 82%">
                                <div id="myChart22" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>

                <div class="left-bottom-1" @mouseover="changIconsBlockPosition('enter', 7)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 100%">
                            <div class="div-index">
                                <p class="cont-top-bg">员工占比</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsSev" class="cont-position" :timeArray="timer"
                                        @chooseData="childByValue" :infoTitle="'员工占比'" @download="download"
                                        :idName="'myChart77'" :stringPaintChart="drawLine7" :allOneValue="countryId"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.YGZB_DATA" />
                                </div>
                            </div>
                            <div class="width-height" style="height: 82%">
                                <div id="myChart77" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import iconsBlock from "./iconsBlock/index.vue";
import { exportImg } from "../../utils/downLoad.js";
import $ from "jquery";
import {
    GetRegionalStaffYoyRateByDateRange,
    GetRegionalStaffAddVallueByDateRange,
    GetRegionalStaffPerformanceByDateRange,
    GetRegionalRecruitmentKeepRate,
    GetRegionalClosePersentByDateRange,
    GetRegionalTargetPersentByDateRange,
    GetRegionalStaffLevelByDateRange,
    GetRegionComboBox,
} from "@/api/api";
import COUNSTDATE from "../../constants/index";

export default {
    components: {
        iconsBlock,
    },
    data() {
        return {
            COUNSTDATE: COUNSTDATE,
            urlData: "",
            isChildText: false,
            allOneValue: 0,
            allOne: [],
            countryId: 0,
            timer: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "本月",
                        onClick(picker) {
                            picker.$emit("pick", [new Date(), new Date()]);
                        },
                    },
                    {
                        text: "今年至今",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近六个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "本季度",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 2);
                            picker.$emit("pick", [start, end]);
                        },
                    },

                    // var currMonth= new Date().getMonth()+1;
                    // var currQuarter = Math.floor( ( currMonth % 3 == 0 ? ( currMonth / 3 ) : ( currMonth / 3 + 1 ) ) );
                ],
            },
            dataTimer: [],
            curDate: "",
            curTime: "",
        };
    },
    computed: {
        getYear() {
            return new Date(this.timer).getFullYear() || new Date().getFullYear();
        },
        isTextColor() {
            return this.isChildText ? "#000" : "#fff";
        },
    },

    mounted() {
        this.comboBoxData();
        this.onClick()
        this.twoClick()
        this.etCountDays()

        var arr = this.timer[1].substring(5, 7)
        if (arr == "01") {
            this.curTime = "-31"
        } else if (arr == "02") {
            this.curTime = "-28"
        } else if (arr == "03") {
            this.curTime = "-31"
        } else if (arr == "04") {
            this.curTime = "-30"
        } else if (arr == "05") {
            this.curTime = "-31"
        } else if (arr == "06") {
            this.curTime = "-30"
        } else if (arr == "07") {
            this.curTime = "-31"
        } else if (arr == "08") {
            this.curTime = "-31"
        } else if (arr == "09") {
            this.curTime = "-30"
        } else if (arr == "10") {
            this.curTime = "-31"
        } else if (arr == "11") {
            this.curTime = "-30"
        } else if (arr == "12") {
            this.curTime = "-31"
        }

        this.topDataOne();
        this.drawLine2();
        this.drawLine3();
        this.drawLine4();
        this.drawLine5();
        this.drawLine6();
        this.drawLine7();
    },

    methods: {

        etCountDays() {
            let curDate = new Date()
            let curMonth = curDate.getMonth()
            curDate.setMonth(curMonth + 1)
            curDate.setDate(0)
            /* 返回当月的天数和月份 */
            this.curDate = curDate.getDate()
            return { day: curDate.getDate(), month: curMonth + 1 }
        },

        childByValue(data, value, countryValue, companyValue) {
            console.log('[ countryValue ] >', countryValue)
            if (data != undefined) {
                this.timer = value
                var arr = value[1].substring(5, 7)
                if (arr == "01") {
                    this.curTime = "-31"
                } else if (arr == "02") {
                    this.curTime = "-28"
                } else if (arr == "03") {
                    this.curTime = "-31"
                } else if (arr == "04") {
                    this.curTime = "-30"
                } else if (arr == "05") {
                    this.curTime = "-31"
                } else if (arr == "06") {
                    this.curTime = "-30"
                } else if (arr == "07") {
                    this.curTime = "-31"
                } else if (arr == "08") {
                    this.curTime = "-31"
                } else if (arr == "09") {
                    this.curTime = "-30"
                } else if (arr == "10") {
                    this.curTime = "-31"
                } else if (arr == "11") {
                    this.curTime = "-30"
                } else if (arr == "12") {
                    this.curTime = "-31"
                }
                this.countryId = countryValue
            }
            if (data == undefined) {
                console.log("[ 123 ] >", 123);
            } else if (data == "myChartC") {
                this.topDataOne()
            } else if (data == "myChart22") {
                this.drawLine2()
            } else if (data == "myChart33") {
                this.drawLine3()
            } else if (data == "myChart44") {
                this.drawLine4()
            } else if (data == "myChart55") {
                this.drawLine5()
            } else if (data == "myChart66") {
                this.drawLine6()
            } else if (data == "myChart77") {
                this.drawLine7()
            }
        },



        //本季度开始
        onClick(picker) {
            var now = new Date(); // 当前日期
            var nowMonth = now.getMonth(); // 当前月
            var nowYear = now.getYear(); // 当前年
            nowYear += (nowYear < 2000) ? 1900 : 0;
            let m = 0;
            if (nowMonth < 3) {//012
                m = 0
            } else if (2 < nowMonth && nowMonth < 6) {//345
                m = 3
            } else if (5 < nowMonth && nowMonth < 8) {//678
                m = 6
            } else if (nowMonth > 8) { //9 10 11
                m = 9
            }
            let quarterStart = new Date(nowYear, m, 1)

            this.formatDate(quarterStart)
        },
        //本季度结束
        twoClick(picker) {
            var now = new Date(); // 当前日期
            var nowMonth = now.getMonth(); // 当前月
            var nowYear = now.getYear(); // 当前年
            nowYear += (nowYear < 2000) ? 1900 : 0;
            let i = 0;
            if (nowMonth < 3) {//012
                i = 3
            } else if (2 < nowMonth && nowMonth < 6) {//345
                i = 6
            } else if (5 < nowMonth && nowMonth < 8) {//678
                i = 9
            } else if (nowMonth > 8) { //9 10 11
                i = 0
            }

            let quarterEnd = new Date(nowYear, i, 1).getTime() - (60 * 60 * 24 * 1000)
            let aa = Date(parseInt(quarterEnd) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ')
            this.formatDate(new Date(aa))
        },

        formatDate(date) {
            var myyear = date.getFullYear();
            var mymonth = date.getMonth() + 1;
            var myweekday = date.getDate();
            if (mymonth < 10) {
                mymonth = "0" + mymonth;
            }
            if (myweekday < 10) {
                myweekday = "0" + myweekday;
            }
            this.timer.push(myyear + "-" + mymonth)
            return (myyear + "-" + mymonth);
        },




        handleTime() {
            var arr = this.timer[1].substring(5, 7)
            if (arr == "01") {
                this.curTime = "-31"
            } else if (arr == "02") {
                this.curTime = "-28"
            } else if (arr == "03") {
                this.curTime = "-31"
            } else if (arr == "04") {
                this.curTime = "-30"
            } else if (arr == "05") {
                this.curTime = "-31"
            } else if (arr == "06") {
                this.curTime = "-30"
            } else if (arr == "07") {
                this.curTime = "-31"
            } else if (arr == "08") {
                this.curTime = "-31"
            } else if (arr == "09") {
                this.curTime = "-30"
            } else if (arr == "10") {
                this.curTime = "-31"
            } else if (arr == "11") {
                this.curTime = "-30"
            } else if (arr == "12") {
                this.curTime = "-31"
            }
            this.topDataOne();
            this.drawLine2();
            this.drawLine3();
            this.drawLine4();
            this.drawLine5();
            this.drawLine6();
            this.drawLine7();
        },
        allOneClick(v) {
            this.countryId = v.value;
            this.topDataOne();
            this.drawLine2();
            this.drawLine3();
            this.drawLine4();
            this.drawLine5();
            this.drawLine6();
            this.drawLine7();
        },

        // 获取全国大区
        comboBoxData() {
            GetRegionComboBox({ ticket: this.urlData }).then((res) => {
                this.allOneValue = res.Data[0].RegionName;
                this.countryId = res.Data[0].Id;

                res.Data.forEach((e) => {
                    const item = {
                        value: e.Id,
                        label: e.RegionName,
                    };
                    this.allOne.push(item);
                });
            });
        },

        //在职人数同比增长
        topDataOne() {
            let param = {
                regionId: this.countryId,
                DateFrom: this.timer[0] + "-01",
                DateTo: this.timer[1] + this.curTime,
                ticket: this.urlData,
            };
            GetRegionalStaffYoyRateByDateRange(param).then((res) => {
                if (res.Status === 1) {
                    var cityArr = [];
                    var dataArr1 = [];
                    var dataArr2 = [];
                    res.Data.forEach((e) => {
                        cityArr.push(e.Name);
                        const item = {
                            value: (e.YoyRate * 100).toFixed(2),
                            number: e.Zaizhi - e.YZaizhi
                        }
                        dataArr1.push(item);
                        dataArr2.push(e.Zaizhi - e.YZaizhi)
                    });
                    let myChart = this.$echarts.init(document.getElementById("myChartC"));
                    // 绘制图表
                    myChart.setOption({
                        tooltip: {
                            // trigger: "axis",
                            // formatter: "{b}: {c}%",
                            // axisPointer: {
                            //     type: "shadow",
                            // },净增人数：${params.data.number}


                            formatter(params) {
                                // 返回值就是html代码可以使用标签
                                return `
                                ${params.name}：${params.data.value}% </br> 
                                `;
                            },
                            axisPointer: { // 坐标轴指示器，坐标轴触发有效
                                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                            }
                        },
                        grid: {
                            top: "5%",
                            left: "8%",
                            right: "3%",
                            bottom: "25%",
                        },

                        dataZoom: [
                            {
                                type: 'slider',
                                realtime: true,
                                // start: 0,
                                // end: 5,  // 数据窗口范围的结束百分比。范围是：0 ~ 100。
                                height: 5, //组件高度
                                left: 5, //左边的距离
                                right: 5, //右边的距离
                                bottom: 10, //下边的距离
                                show: true,  // 是否展示
                                startValue: 0, // 从头开始。
                                endValue: 10, // 一次性展示6个
                                fillerColor: "rgba(17, 100, 210, 0.42)", // 滚动条颜色
                                borderColor: "rgba(17, 100, 210, 0.12)",
                                handleSize: 0,      //两边手柄尺寸
                                showDetail: false, //拖拽时是否展示滚动条两侧的文字
                                zoomLock: true,         //是否只平移不缩放
                                moveOnMouseMove: false //鼠标移动能触发数据窗口平移
                                //zoomOnMouseWheel: false, //鼠标移动能触发数据窗口缩放
                            },
                            {
                                type: "inside",  // 支持内部鼠标滚动平移
                                start: 0,
                                end: 5,
                                zoomOnMouseWheel: false,  // 关闭滚轮缩放
                                moveOnMouseWheel: true, // 开启滚轮平移
                                moveOnMouseMove: true  // 鼠标移动能触发数据窗口平移 
                            }
                        ],

                        xAxis: [
                            {
                                type: "category",
                                data: cityArr,
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 35,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                                axisTick: {
                                    alignWithLabel: true,
                                },
                            },
                        ],
                        yAxis: [
                            {
                                type: "value",
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 25,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                            },
                        ],
                        series: [
                            {
                                type: "bar",
                                barWidth: "25%",
                                itemStyle: {
                                    //配置样式，设置每个柱子的颜色
                                    normal: {
                                        color: function (params) {
                                            var colorList = ["#1C82FF"];
                                            return colorList[0];
                                        },
                                        label: {
                                            show: false, //开启显示
                                            formatter(params) {
                                                return params.data.number
                                            },
                                            position: 'top', //在上方显示
                                            textStyle: {
                                                //数值样式
                                                color: this.isTextColor,
                                                fontSize: 10,
                                            },
                                        },
                                    },
                                },
                                data: dataArr1,
                            },
                        ],
                    });
                }
            });
        },

        // 招聘完成率
        drawLine2() {
            let param = {
                regionId: this.countryId,
                DateFrom: this.timer[0] + "-01",
                DateTo: this.timer[1] + this.curTime,
                ticket: this.urlData,
            };
            GetRegionalTargetPersentByDateRange(param).then((res) => {
                if (res.Status === 1) {
                    var cityArr = [];
                    var dataArr1 = [];
                    res.Data.forEach((e) => {
                        cityArr.push(e.Name);
                        dataArr1.push((e.TargetPersent * 100).toFixed(2));
                    });
                    let myChart = this.$echarts.init(document.getElementById("myChart22"));
                    // 绘制图表
                    myChart.setOption({
                        tooltip: {
                            trigger: "axis",
                            formatter: "{b}: {c}%",
                            axisPointer: {
                                type: "shadow",
                            },
                        },
                        grid: {
                            top: "10",
                            left: "40",
                            right: "10",
                            bottom: "55",
                        },
                        dataZoom: [
                            {
                                type: 'slider',
                                realtime: true,
                                // start: 0,
                                // end: 5,  // 数据窗口范围的结束百分比。范围是：0 ~ 100。
                                height: 5, //组件高度
                                left: 5, //左边的距离
                                right: 5, //右边的距离
                                bottom: 10, //下边的距离
                                show: true,  // 是否展示
                                startValue: 0, // 从头开始。
                                endValue: 12, // 一次性展示6个
                                fillerColor: "rgba(17, 100, 210, 0.42)", // 滚动条颜色
                                borderColor: "rgba(17, 100, 210, 0.12)",
                                handleSize: 0,      //两边手柄尺寸
                                showDetail: false, //拖拽时是否展示滚动条两侧的文字
                                zoomLock: true,         //是否只平移不缩放
                                moveOnMouseMove: false //鼠标移动能触发数据窗口平移
                                //zoomOnMouseWheel: false, //鼠标移动能触发数据窗口缩放
                            },
                            {
                                type: "inside",  // 支持内部鼠标滚动平移
                                start: 0,
                                end: 5,
                                zoomOnMouseWheel: false,  // 关闭滚轮缩放
                                moveOnMouseWheel: true, // 开启滚轮平移
                                moveOnMouseMove: true  // 鼠标移动能触发数据窗口平移 
                            }
                        ],
                        xAxis: [
                            {
                                type: "category",
                                data: cityArr,
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 35,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                                axisTick: {
                                    alignWithLabel: true,
                                },
                            },
                        ],
                        yAxis: [
                            {
                                type: "value",
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 25,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                            },
                        ],
                        series: [
                            {
                                name: "完成率",
                                type: "bar",
                                barWidth: "25%",
                                itemStyle: {
                                    //配置样式，设置每个柱子的颜色
                                    normal: {
                                        color: function (params) {
                                            var colorList = ["#FFB377"];
                                            return colorList[0];
                                        },
                                    },
                                },
                                data: dataArr1,
                            },
                        ],
                    });
                }
            });
        },

        // 人员净增
        drawLine3() {
            let param = {
                regionId: this.countryId,
                DateFrom: this.timer[0] + "-01",
                DateTo: this.timer[1] + this.curTime,
                ticket: this.urlData,
            };
            GetRegionalStaffAddVallueByDateRange(param).then((res) => {
                if (res.Status === 1) {
                    var cityArr = [];
                    var dataArr1 = [];
                    var dataArr2 = [];
                    var dataArr3 = [];
                    res.Data.forEach((e) => {
                        cityArr.push(e.Name);
                        dataArr1.push(e.Ruzhi);
                        dataArr2.push(e.Lizhi);
                        dataArr3.push(e.AddValue);
                    });
                    const colors = ["#5470C6", "#91CC75", "#EE6666"];
                    let myChart = this.$echarts.init(document.getElementById("myChart33"));
                    myChart.setOption({
                        color: colors,
                        tooltip: {
                            trigger: "axis",

                        },
                        grid: {
                            top: "15",
                            left: "40",
                            right: "25",
                            bottom: "65",
                        },
                        dataZoom: [
                            {
                                type: 'slider',
                                realtime: true,
                                // start: 0,
                                // end: 5,  // 数据窗口范围的结束百分比。范围是：0 ~ 100。
                                height: 5, //组件高度
                                left: 5, //左边的距离
                                right: 5, //右边的距离
                                bottom: 10, //下边的距离
                                show: true,  // 是否展示
                                startValue: 0, // 从头开始。
                                endValue: 12, // 一次性展示6个
                                fillerColor: "rgba(17, 100, 210, 0.42)", // 滚动条颜色
                                borderColor: "rgba(17, 100, 210, 0.12)",
                                handleSize: 0,      //两边手柄尺寸
                                showDetail: false, //拖拽时是否展示滚动条两侧的文字
                                zoomLock: true,         //是否只平移不缩放
                                moveOnMouseMove: false //鼠标移动能触发数据窗口平移
                                //zoomOnMouseWheel: false, //鼠标移动能触发数据窗口缩放
                            },
                            {
                                type: "inside",  // 支持内部鼠标滚动平移
                                start: 0,
                                end: 5,
                                zoomOnMouseWheel: false,  // 关闭滚轮缩放
                                moveOnMouseWheel: true, // 开启滚轮平移
                                moveOnMouseMove: true  // 鼠标移动能触发数据窗口平移 
                            }
                        ],
                        legend: {
                            bottom: "15",
                            textStyle: {
                                color: this.isChildText ? "#000" : "#f2f2f2",
                                fontSize: 10,
                            },
                            itemWidth: 12,
                            itemHeight: 12,
                            data: ["入职", "离职", "净增"],
                        },
                        xAxis: [
                            {
                                type: "category",
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },

                                axisLabel: {
                                    interval: 0,
                                    rotate: 35,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                        color: this.isTextColor,
                                    },
                                },
                                axisTick: {
                                    alignWithLabel: true,
                                },
                                // prettier-ignore
                                data: cityArr,
                            },
                        ],
                        yAxis: [
                            {
                                type: "value",
                                name: "入职",
                                position: "none",
                                show: true,
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 25,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                            },
                            {
                                type: "value",
                                name: "离职",
                                position: "right",
                                show: false,
                                offset: 80,
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 25,
                                    color: this.isTextColor,
                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                            },
                            {
                                type: "value",
                                name: "净增",
                                position: "right",
                                alignTicks: false,
                                show: true,
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 25,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                            },
                        ],
                        series: [
                            {
                                name: "入职",
                                type: "bar",
                                barWidth: "15%",
                                data: dataArr1,
                            },
                            {
                                name: "离职",
                                type: "bar",
                                barWidth: "15%",
                                yAxisIndex: 1,
                                data: dataArr2,
                            },
                            {
                                name: "净增",
                                type: "line",
                                yAxisIndex: 2,
                                data: dataArr3,
                            },
                        ],
                    });
                }
            });
        },

        // 人效
        drawLine4() {
            let param = {
                regionId: this.countryId,
                DateFrom: this.timer[0] + "-01",
                DateTo: this.timer[1] + this.curTime,
                ticket: this.urlData,
            };
            GetRegionalStaffPerformanceByDateRange(param).then((res) => {
                if (res.Status === 1) {
                    var cityArr = [];
                    var dataArr1 = [];
                    res.Data.forEach((e) => {
                        cityArr.push(e.Name);
                        dataArr1.push(e.StaffPerformance);
                    });

                    let myChart = this.$echarts.init(document.getElementById("myChart44"));
                    myChart.setOption({
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "shadow",
                            },
                        },
                        grid: {
                            top: "15",
                            left: "40",
                            right: "3",
                            bottom: "40",
                        },
                        xAxis: [
                            {
                                type: "category",
                                data: cityArr,
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 35,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                                axisTick: {
                                    alignWithLabel: true,
                                },
                            },
                        ],
                        yAxis: [
                            {
                                type: "value",
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 35,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                            },
                        ],
                        series: [
                            {
                                name: "人效",
                                type: "bar",
                                barWidth: "10",
                                itemStyle: {
                                    //配置样式，设置每个柱子的颜色
                                    normal: {
                                        color: function (params) {
                                            var colorList = ["#F8D135"];
                                            return colorList[0];
                                        },
                                    },
                                },
                                data: dataArr1,
                            },
                        ],
                    });
                }
            });
        },

        //招聘留存率
        drawLine5() {
            let param = {
                regionId: this.countryId,
                DateFrom: this.timer[0] + "-01",
                DateTo: this.timer[1] + this.curTime,
                ticket: this.urlData,
            };
            GetRegionalRecruitmentKeepRate(param).then((res) => {
                if (res.Status === 1) {
                    var cityArr = [];
                    var dataArr1 = [];
                    res.Data.forEach((e) => {
                        cityArr.push(e.Name);
                        dataArr1.push((e.KeepRate * 100).toFixed(2));
                    });
                    let myChart = this.$echarts.init(document.getElementById("myChart55"));
                    myChart.setOption({
                        tooltip: {
                            trigger: "item",
                            formatter: "{b}: {c}%",
                        },
                        grid: {
                            top: "10",
                            left: "40",
                            right: "15",
                            bottom: "40",
                        },
                        xAxis: [
                            {
                                type: "category",
                                data: cityArr,
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 35,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                                axisTick: {
                                    alignWithLabel: true,
                                },
                            },
                        ],
                        yAxis: [
                            {
                                type: "value",
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "0", //坐标线的宽度
                                    },
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 25,
                                    color: this.isTextColor,
                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                            },
                        ],
                        series: [
                            {
                                name: "留存率",
                                type: "bar",
                                barWidth: "10",
                                itemStyle: {
                                    //配置样式，设置每个柱子的颜色
                                    normal: {
                                        color: function (params) {
                                            var colorList = ["#48E3EC"];
                                            return colorList[0];
                                        },
                                    },
                                },
                                data: dataArr1,
                            },
                        ],
                    });
                }
            });
        },
        //离职替换率
        drawLine6() {
            let param = {
                regionId: this.countryId,
                DateFrom: this.timer[0] + "-01",
                DateTo: this.timer[1] + this.curTime,
                ticket: this.urlData,
            };
            GetRegionalClosePersentByDateRange(param).then((res) => {
                if (res.Status === 1) {
                    var cityArr = [];
                    var dataArr1 = [];
                    res.Data.forEach((e) => {
                        cityArr.push(e.Name);
                        dataArr1.push((e.ClosePersent * 100).toFixed(2))
                    });
                    const colors = ["#5470C6", "#91CC75", "#EE6666"];
                    let myChart = this.$echarts.init(document.getElementById("myChart66"));
                    myChart.setOption({
                        tooltip: {
                            trigger: "item",
                            formatter: "{b}: {c}%",
                        },
                        grid: {
                            top: "10",
                            left: "40",
                            right: "10",
                            bottom: "55",
                        },
                        dataZoom: [
                            {
                                type: 'slider',
                                realtime: true,
                                // start: 0,
                                // end: 5,  // 数据窗口范围的结束百分比。范围是：0 ~ 100。
                                height: 5, //组件高度
                                left: 5, //左边的距离
                                right: 5, //右边的距离
                                bottom: 10, //下边的距离
                                show: true,  // 是否展示
                                startValue: 0, // 从头开始。
                                endValue: 12, // 一次性展示6个
                                fillerColor: "rgba(17, 100, 210, 0.42)", // 滚动条颜色
                                borderColor: "rgba(17, 100, 210, 0.12)",
                                handleSize: 0,      //两边手柄尺寸
                                showDetail: false, //拖拽时是否展示滚动条两侧的文字
                                zoomLock: true,         //是否只平移不缩放
                                moveOnMouseMove: false //鼠标移动能触发数据窗口平移
                                //zoomOnMouseWheel: false, //鼠标移动能触发数据窗口缩放
                            },
                            {
                                type: "inside",  // 支持内部鼠标滚动平移
                                start: 0,
                                end: 5,
                                zoomOnMouseWheel: false,  // 关闭滚轮缩放
                                moveOnMouseWheel: true, // 开启滚轮平移
                                moveOnMouseMove: true  // 鼠标移动能触发数据窗口平移 
                            }
                        ],
                        xAxis: [
                            {
                                type: "category",
                                data: cityArr,
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "1", //坐标线的宽度
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 35,
                                    color: this.isTextColor,

                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                                axisTick: {
                                    alignWithLabel: true,
                                },
                            },
                        ],
                        yAxis: [
                            {
                                type: "value",
                                axisLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "#404666", //左边线的颜色
                                        width: "0", //坐标线的宽度
                                    },
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisLabel: {
                                    interval: 0,
                                    rotate: 25,
                                    color: this.isTextColor,
                                    textStyle: {
                                        fontSize: "10px",
                                    },
                                },
                            },
                        ],
                        series: [
                            {
                                name: "替换率",
                                type: "bar",
                                barWidth: "25%",
                                data: dataArr1,
                            },
                        ],
                    });
                }
            });
        },
        //各地员工占比
        drawLine7() {
            let param = {
                regionId: this.countryId,
                DateFrom: this.timer[0] + "-01",
                DateTo: this.timer[1] + this.curTime,
                ticket: this.urlData,
            };
            GetRegionalStaffLevelByDateRange(param).then((res) => {
                if (res.Status === 1) {
                    var cityArr = [];
                    var dataArr1 = [];
                    var dataArr2 = [];
                    var dataArr3 = [];
                    var dataArr4 = [];
                    var dataArr5 = [];
                    var dataArr6 = [];

                    var sDataArry1=[]
                    var sDataArry2=[]
                    var sDataArry3=[]
                    var sDataArry4=[]
                    var sDataArry5=[]
                    var sDataArry6=[]

                    res.Data.forEach((e) => {
                        cityArr.push(e.Name);
                    });

                    var temp = []; //一个新的临时数组
                    for (var i = 0; i < cityArr.length; i++) {
                        if (temp.indexOf(cityArr[i]) == -1) {
                            temp.push(cityArr[i]);
                        }
                    }
                    temp.forEach((e,index) => {
                        let a = res.Data.filter((s) => {
                            return s.Name == e;
                        });
                        (() => {
                            let b = a.find((s) => {
                                return s.PerformanceAmountLevel == "L0";
                            });
                            if (b) dataArr1.push(b.LevelCount);
                            else dataArr1.push(0);
                        })();
                        (() => {
                            let b = a.find((s) => {
                                return s.PerformanceAmountLevel == "L1";
                            });
                            if (b) dataArr2.push(b.LevelCount);
                            else dataArr2.push(0);
                        })();
                        (() => {
                            let b = a.find((s) => {
                                return s.PerformanceAmountLevel == "L2";
                            });
                            if (b) dataArr3.push(b.LevelCount);
                            else dataArr3.push(0);
                        })();
                        (() => {
                            let b = a.find((s) => {
                                return s.PerformanceAmountLevel == "L3";
                            });
                            if (b) dataArr4.push(b.LevelCount);
                            else dataArr4.push(0);
                        })();
                        (() => {
                            let b = a.find((s) => {
                                return s.PerformanceAmountLevel == "L4";
                            });
                            if (b) dataArr5.push(b.LevelCount);
                            else dataArr5.push(0);
                        })();
                        (() => {
                            let b = a.find((s) => {
                                return s.PerformanceAmountLevel == "L5及以上";
                            });
                            if (b) dataArr6.push(b.LevelCount);
                            else dataArr6.push(0);
                        })();

                        sDataArry1.push((dataArr1[index]/(dataArr1[index]+dataArr2[index]+dataArr3[index]+dataArr4[index]+dataArr5[index]+dataArr6[index])*100).toFixed(2))
                        sDataArry2.push((dataArr2[index]/(dataArr1[index]+dataArr2[index]+dataArr3[index]+dataArr4[index]+dataArr5[index]+dataArr6[index])*100).toFixed(2))
                        sDataArry3.push((dataArr3[index]/(dataArr1[index]+dataArr2[index]+dataArr3[index]+dataArr4[index]+dataArr5[index]+dataArr6[index])*100).toFixed(2))
                        sDataArry4.push((dataArr4[index]/(dataArr1[index]+dataArr2[index]+dataArr3[index]+dataArr4[index]+dataArr5[index]+dataArr6[index])*100).toFixed(2))
                        sDataArry5.push((dataArr5[index]/(dataArr1[index]+dataArr2[index]+dataArr3[index]+dataArr4[index]+dataArr5[index]+dataArr6[index])*100).toFixed(2))
                        sDataArry6.push((dataArr6[index]/(dataArr1[index]+dataArr2[index]+dataArr3[index]+dataArr4[index]+dataArr5[index]+dataArr6[index])*100).toFixed(2))



                    });

                    let myChart = this.$echarts.init(document.getElementById("myChart77"));
                    myChart.setOption({
                        tooltip: {
                            trigger: "axis",
                            formatter: ' {a0}: {c0}%</br>{a1}: {c1}%</br>{a2}: {c2}%</br>{a3}: {c3}%</br>{a4}: {c4}%</br>{a5}: {c5}%',

                            axisPointer: {
                                type: "cross",
                            },
                        },
                        angleAxis: {
                            type: "category",
                            startAngle: 90,
                            data: temp,
                            fontSize: 10,
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: ["#fff", "#fff"],
                                    type: "solid",
                                },
                            },
                        },
                        grid: {
                            top: "3%",
                            left: "8%",
                            right: "8%",
                            bottom: "20%",
                        },
                        radiusAxis: {},
                        polar: {
                            center: ["50%", "45%"],
                            radius: ["0%", "60%"],
                        },
                        series: [
                            {
                                type: "bar",
                                data: sDataArry1,
                                coordinateSystem: "polar",
                                name: "L0",
                                stack: "L0",
                                emphasis: {
                                    focus: "series",
                                },
                            },
                            {
                                type: "bar",
                                data: sDataArry2,
                                coordinateSystem: "polar",
                                name: "L1",
                                stack: "L1",
                                emphasis: {
                                    focus: "series",
                                },
                            },
                            {
                                type: "bar",
                                data: sDataArry3,
                                coordinateSystem: "polar",
                                name: "L2",
                                stack: "L2",
                                emphasis: {
                                    focus: "series",
                                },
                            },
                            {
                                type: "bar",
                                data: sDataArry4,
                                coordinateSystem: "polar",
                                name: "L3",
                                stack: "L3",
                                emphasis: {
                                    focus: "series",
                                },
                            },
                            {
                                type: "bar",
                                data: sDataArry5,
                                coordinateSystem: "polar",
                                name: "L4",
                                stack: "L4",
                                emphasis: {
                                    focus: "series",
                                },
                            },
                            {
                                type: "bar",
                                data: sDataArry6,
                                coordinateSystem: "polar",
                                name: "L5及以上",
                                stack: "L5及以上",
                                emphasis: {
                                    focus: "series",
                                },
                            },
                        ],
                        legend: {
                            show: true,
                            bottom: "3%",
                            textStyle: {
                                color: this.isChildText ? "#000" : "#f2f2f2",
                                fontSize: 10,
                            },
                            data: ["L0", "L1", "L2", "L3", "L4", "L5及以上"],
                        },
                    });
                }
            });
        },

        changIconsBlockPosition(str, index) {
            if (str === "enter") {
                if (index === 1) {
                    this.$refs.iconsFir.$el.classList.add("cont-position-act");
                }
                if (index == 2) {
                    this.$refs.iconsSec.$el.classList.add("cont-position-act");
                }
                if (index == 3) {
                    this.$refs.iconsThr.$el.classList.add("cont-position-act");
                }
                if (index == 4) {
                    this.$refs.iconsFou.$el.classList.add("cont-position-act");
                }
                if (index == 5) {
                    this.$refs.iconsFiv.$el.classList.add("cont-position-act");
                }
                if (index == 6) {
                    this.$refs.iconsSix.$el.classList.add("cont-position-act");
                }
                if (index == 7) {
                    this.$refs.iconsSev.$el.classList.add("cont-position-act");
                }
            } else {
                this.$refs.iconsFir.$el.classList.remove("cont-position-act");
                this.$refs.iconsSec.$el.classList.remove("cont-position-act");
                this.$refs.iconsThr.$el.classList.remove("cont-position-act");
                this.$refs.iconsFou.$el.classList.remove("cont-position-act");
                this.$refs.iconsFiv.$el.classList.remove("cont-position-act");
                this.$refs.iconsSix.$el.classList.remove("cont-position-act");
                this.$refs.iconsSev.$el.classList.remove("cont-position-act");
            }
        },

        changeTextColor(status) {
            this.isChildText = status;
        },
        download(idName, imgName = "chart") {
            exportImg(idName, imgName);
        },
    },

    created() {
        var urlData1 = this.$route.query.ticket; //url.substring(url.lastIndexOf('ticket') + 7);
        if (urlData1 != "" && urlData1 != undefined && urlData1 != null) {
            sessionStorage.setItem("urlData", urlData1);
        }
        this.urlData = sessionStorage.getItem("urlData");

        // Vue.prototype.$urlData=sessionStorage.getItem("urlData")
    },
};
</script>


<style scoped>
.personnel {
    width: 100vw;
    height: 97vh;
    /* display: flex; */
}

.index-cont {
    width: 97%;
    height: 90%;
    padding: 19px 25px 31px;
    display: flex;
    justify-content: space-between;
}

.top-select {
    margin: 15px 25px 0;
}

.div-index {
    height: 14%;
    /* position: absolute; */
    width: 100%;
    /* z-index: 999; */
}

.index-1 {
    width: 31.33%;
    height: 100%;
    /* background: chartreuse; */
}

.index-2 {
    flex: 1;
    width: 37.33%;
    margin: 0 26px;
    height: 100%;
    /* background:chocolate ; */
}

.index-3 {
    width: 31.33%;
    height: 100%;
    /* background: chartreuse; */
}

.border-left-1,
.border-right-1 {
    width: 100%;
    height: 30%;
}

.border-left-2,
.border-right-2 {
    margin: 10px 0;
    width: 100%;
    height: 30%;
}

.left-top-1 {
    margin-bottom: 10px;
}

.left-top-1,
.left-bottom-1 {
    width: 100%;
    height: 46.5%;
}

.border-left-3,
.border-right-3 {
    width: 100%;
    height: 25%;
}

.border-middle-1 {
    width: 100%;
    height: 10%;
}

.border-middle-2 {
    width: 100%;
    height: 50%;
    margin: 10px 0;
}

.middle-topOne {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.border-middle-3 {
    width: 100%;
    height: 25%;
}

.echarts1 {
    color: #fff;
    padding: 16px 8px;
}

>>>.el-input__inner {
    background: none !important;
    border: 1px solid #1ac9ff !important;
    color: #fff;
}

/* 阴影 */
>>>.dv-border-box-7 .dv-border-svg-container>polyline {
    stroke: #1eb0fc;
}

>>>.dv-border-box-7 {
    box-shadow: 0px 0px 10px 0px #7580be inset !important;
}

>>>.dv-border-box-7:hover {
    box-shadow: 0px 0px 10px 0px #ffdf38 inset !important;
}

>>>.dv-border-box-7 .dv-border-svg-container>polyline:nth-child(2),
>>>.dv-border-box-7 .dv-border-svg-container>polyline:nth-child(4) {
    display: none !important;
}

>>>.dv-border-box-7 .dv-bb7-line-width-5 {
    display: none !important;
}

>>>.dv-border-box-7 .dv-bb7-line-width-2 {
    stroke-width: 4;
}

>>>.dv-border-box-7:hover .right-top polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .left-top polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .right-bottom polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .left-bottom polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}


.cont-top-bg {
    background: url(../../assets/img/cont-bg-four.png) no-repeat;
}

.cont-top-bg6 {
    background: url(../../assets/img/cont-bg-eight.png) no-repeat;
}

.cont-bg-event {
    width: 180px;
    display: inline-block;
    padding: 5px 52px 5px 12px;
    background: url(../../assets/img/cont-bg-eight.png) no-repeat;
    letter-spacing: 1px;
    font-size: 16px;
    /* min-width: 172px; */
    background-size: 100%;
    /* position: absolute; */
    /* text-align: center; */
    background-position: center;
    height: 32px;
    line-height: 32px;
}

.cont-top-bg6,
.cont-top-bg {
    padding: 5px 92px 5px 12px;
    letter-spacing: 1px;
    font-size: 16px;
    /* min-width: 92px; */
    background-size: 100%;
    position: absolute;
    /* text-align: center; */
    background-position: center;
    height: 26px;
    line-height: 26px;
}

.swiper-data {
    margin-top: 45px;
    width: 100%;
    height: 170px;
}

.middle-top {
    width: 100%;
    display: flex;
    padding: 5px 0;
}

.middle-top-div {
    width: 20%;
    text-align: center;
    display: flex;
    justify-content: center;
}

.middle-top-num {
    font-weight: 600;
    color: #ffdf38;
    line-height: 30px;
    letter-spacing: 1px;
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    width: 172px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    word-break: break-all;
}

.middle-top-text {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    letter-spacing: 1px;
}

.middle-line {
    border-left: 1px solid #404666;
}

.width-height {
    width: 96%;
    height: 80%;
    position: absolute;
}

.middle-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
}

.cont-position {
    position: relative;
    left: 112px;
    transition: all 0.3s linear;
}

.cont-position-act {
    left: 0px;
}

.icons-block {
    overflow: hidden;
    margin-right: 6px;
    padding: 4px 2px;
    position: absolute;
    right: 8px;
    display: inline-block;
    /* z-index: 99999; */
}

@media (min-width: 1279px) and (max-width: 1365px) {
    .index {
        height: 90vh;
    }

    .personnel {
        height: 90vh;
    }

    .index-2 {
        margin: 0 16px;
    }

    .border-left-1,
    .border-right-1 {
        height: 33%;
    }

    .left-top-1,
    .left-bottom-1 {
        height: 46.5%;
    }

    .border-left-3,
    .border-right-3 {
        height: 30%;
    }

    .border-middle-2 {
        height: 56%;
    }

    .border-middle-3 {
        height: 30%;
    }

    .index-cont {
        height: 95%;
        padding: 15px 15px;
    }

    .swiper-data {
        height: 77%;
    }

    .echarts1 {
        width: 98%;
        height: 100%;
        overflow: hidden;
        padding: 0px 3px 5px;
    }

    .middle-top-num {
        font-size: 16px;
    }

    .width-height {
        height: 86%;
    }

    .middle-top-text {
        font-size: 12px;
    }

    .cont-bg-event {
        font-size: 12px;
        width: 120px;
    }

    .cont-top-bg6,
    .cont-top-bg {
        font-size: 12px;
    }

    .top-select {
        margin: 15px 15px 0;
    }

    .cont-top-bg6,
    .cont-top-bg {
        margin-top: 10px;
        margin-left: 5px;
        padding: 0 70px 0 12px;
    }
}

>>>.dv-scroll-board .rows .ceil {
    font-size: 12px !important;
}

@media (max-width: 1300px) {
    .middle-top-num {
        width: 100px !important;
    }
}

>>>.el-range-editor .el-range-input {
    background: none;
    color: #fff;
}

>>>.el-date-editor .el-range-separator {
    color: #fff
}
</style>
<style>
.el-month-table td .cell {
    color: #606266;
}

.el-date-range-picker .el-picker-panel__content {
    background: #fff;
}

.el-month-table td.end-date .cell,
.el-month-table td.start-date .cell {
    background: none;
    color: #409eff !important;
}

.el-month-table td.in-range div,
.el-month-table td.in-range div:hover {
    background: none;
}


/* .el-date-editor .el-range-separator {
  color: #fff;
} */
</style>


// WEBPACK FOOTER //
// src/components/dataChart/personnel.vue